import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { fetchSiteMedia } from '../services/api';

const HeroSection = () => {
  const { t } = useLanguage();
  const [isLoaded, setIsLoaded] = useState(false);
  const [bgUrl, setBgUrl] = useState('/hero-bg.jpg');

  useEffect(() => {
    setIsLoaded(true);
    fetchSiteMedia().then((m) => {
      if (m && m.hero_bg) setBgUrl(m.hero_bg);
    });
  }, []);

  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth',
    });
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Static Image Background */}
      <div className="absolute inset-0">
        <img
          src={bgUrl}
          alt="Altınzade Kuyumculuk"
          className="w-full h-full object-cover"
        />
        {/* Gradient Overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6">
        <div
          className={`text-center max-w-4xl transition-all duration-1000 ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Brand Name - Large */}
          <h1 className="text-4xl md:text-5xl lg:text-7xl font-light text-white mb-4 tracking-[0.2em] leading-tight uppercase">
            ALTINZADE KUYUMCULUK
          </h1>
          {/* Subtitle/Tagline */}
          <p
            className={`text-lg md:text-xl text-white/80 mb-10 font-light tracking-wide transition-all duration-1000 delay-300 ${
              isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            {t('hero.subtitle')}
          </p>
          <Link
            to="/collections"
            className={`inline-block px-10 py-5 border border-white text-white text-sm font-medium tracking-widest uppercase transition-all duration-500 hover:bg-white hover:text-[#333333] ${
              isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
            style={{ transitionDelay: '600ms' }}
          >
            {t('hero.cta')}
          </Link>
        </div>

        {/* Scroll Indicator */}
        <button
          onClick={scrollToContent}
          className={`absolute bottom-10 left-1/2 -translate-x-1/2 text-white/70 hover:text-white transition-all duration-500 animate-bounce ${
            isLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          style={{ transitionDelay: '1000ms' }}
        >
          <ChevronDown className="w-8 h-8" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
